import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogContent } from '@material-ui/core'

const Spiner = ({ opt, loadLabel }) => {
  return (
    <>
      <style>
        {`
          @keyframes modernSpin {
            0% {
              transform: rotate(0deg);
            }

            100% {
              transform: rotate(360deg);
            }
          }

          @keyframes pulseGlow {
            0% {
              opacity: .45;
              transform: scale(1);
            }

            50% {
              opacity: .9;
              transform: scale(1.08);
            }

            100% {
              opacity: .45;
              transform: scale(1);
            }
          }

          @keyframes softFloat {
            0% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(-2px);
            }

            100% {
              transform: translateY(0px);
            }
          }
        `}
      </style>

      <Dialog
        open={opt}
        PaperProps={{
          style: {
            background: 'rgba(255,255,255,.96)',
            borderRadius: '32px',
            padding: '42px 58px',
            overflow: 'hidden',
            boxShadow: '0 30px 80px rgba(15,23,42,.16)',
            border: '1px solid rgba(15,23,42,.06)'
          }
        }}
        BackdropProps={{
          style: {
            backgroundColor: 'rgba(15,23,42,.18)',
            backdropFilter: 'blur(7px)'
          }
        }}
      >
        <DialogContent
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            overflow: 'hidden'
          }}
        >
          <div
            style={{
              position: 'relative',
              width: '92px',
              height: '92px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              animation: 'softFloat 3s ease-in-out infinite'
            }}
          >
            <div
              style={{
                position: 'absolute',
                width: '92px',
                height: '92px',
                borderRadius: '50%',
                background:
                  'radial-gradient(rgba(11,114,133,.16), transparent)',
                animation: 'pulseGlow 2.2s ease infinite'
              }}
            />

            <div
              style={{
                width: '72px',
                height: '72px',
                border: '5px solid rgba(15,23,42,.08)',
                borderTop: '5px solid #0B7285',
                borderRadius: '50%',
                animation: 'modernSpin 1s linear infinite'
              }}
            />
          </div>

          <div
            style={{
              marginTop: '30px',
              color: '#12344D',
              fontSize: '22px',
              fontWeight: '700',
              textAlign: 'center',
              letterSpacing: '.2px'
            }}
          >
            {loadLabel}
          </div>

          <div
            style={{
              marginTop: '12px',
              color: '#6B7280',
              fontSize: '14px',
              textAlign: 'center',
              maxWidth: '260px',
              lineHeight: '1.6'
            }}
          >
            Estamos procesando la información
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}

Spiner.propTypes = {
  opt: PropTypes.bool.isRequired,
  loadLabel: PropTypes.string.isRequired
}

export default Spiner
